export default __webpack_public_path__ + "static/conv-6a1eca2595bb6ca9932c7d012cec3eb1.mp4";